// src/components/Seo.jsx
import { Helmet } from "react-helmet-async";
import defaultImage from "../../images/promotionalPhotos/btx-office.jpg";
import { SITE_URL } from "../../config/site";

const DEFAULT_IMAGE = `${SITE_URL}${defaultImage}`;

/**
 * @param {string}  title        Titre complet, déjà suffixé " | Bio-Technofix"
 * @param {string}  description  140-160 caractères
 * @param {string}  path         Chemin canonique, commençant par "/"
 * @param {string}  image        URL absolue en https
 * @param {boolean} noindex      true pour les pages fonctionnelles et la 404
 * @param {object}  jsonLd       Objet JSON-LD unique, ou tableau d'objets
 */
export default function Seo({
  title,
  description,
  path,
  image = DEFAULT_IMAGE,
  noindex = false,
  jsonLd = null,
}) {
  const canonical = path ? `${SITE_URL}${path}` : null;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}
      {noindex && <meta name="robots" content="noindex,follow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Bio-Technofix" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />

      {blocks.map((block, i) => (
        <script type="application/ld+json" key={i}>
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
}
